import React from 'react'

import { useAPIGetPerencanaan } from 'api/kinerja/pengawas-sekolah/perencanaan'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { isPerencanaanV2 as shouldUseV2 } from 'app/KinerjaPSPegawaiPage/utils/perencanaan'
import useToggleSdkContext from 'utils/useToogleSdk'

import type { StatusPerencanaan, TPerencanaan } from 'types/kinerja-ps-pegawai'

type TUsePerencanaanPSHooks = {
  perencanaan: TPerencanaan
  apiStatus: string
  isPraktikKinerjaEditable: boolean
  isPengembanganKompetensiEditable: boolean
  isPerilakuKerjaEditable: boolean
  isPerencanaanV2: boolean
}

const PERENCANAAN_NOT_FINALIZED_STATES: StatusPerencanaan[] = [
  'MULAI_PERENCANAAN',
  'SIAP_DIAJUKAN',
  'DIARAHKAN_REVISI_TK',
  'DIARAHKAN_REVISI_PPK',
]

const PERENCANAAN_NOT_FINALIZED_V2_STATES: StatusPerencanaan[] = [
  'MULAI_PERENCANAAN',
  'DIARAHKAN_REVISI_TK',
  'DIARAHKAN_REVISI_PPK',
]

export const usePerencanaanPS = (): TUsePerencanaanPSHooks => {
  const { period, isHavePeriod, periodYear } = usePeriodContext()
  const { data: perencanaan, status: apiStatus } = useAPIGetPerencanaan({
    periodId: period.id,
    enabled: isHavePeriod,
  })
  const toggle = useToggleSdkContext()

  const isPerencanaanV2 =
    (shouldUseV2(periodYear) &&
      toggle?.['kinerja-ps-pegawai-perencanaan-v2-enabled']) ||
    false

  const isPraktikKinerjaEditable = React.useMemo(
    () =>
      (isPerencanaanV2
        ? PERENCANAAN_NOT_FINALIZED_V2_STATES
        : PERENCANAAN_NOT_FINALIZED_STATES
      ).includes(perencanaan?.praktikKinerjaStatus),
    [perencanaan?.praktikKinerjaStatus, isPerencanaanV2]
  )
  const isPengembanganKompetensiEditable = React.useMemo(
    () =>
      PERENCANAAN_NOT_FINALIZED_STATES.includes(
        perencanaan?.pengembanganKompetensiStatus
      ),
    [perencanaan?.pengembanganKompetensiStatus]
  )
  const isPerilakuKerjaEditable = React.useMemo(
    () =>
      PERENCANAAN_NOT_FINALIZED_STATES.includes(
        perencanaan?.perilakuKerjaStatus
      ),
    [perencanaan?.perilakuKerjaStatus]
  )

  return {
    perencanaan,
    apiStatus,
    isPraktikKinerjaEditable,
    isPengembanganKompetensiEditable,
    isPerilakuKerjaEditable,
    isPerencanaanV2,
  }
}

export const usePerencanaanV2 = () => {
  const toggle = useToggleSdkContext()
  const { periodYear } = usePeriodContext()
  const isPerencanaanV2 =
    (shouldUseV2(periodYear) &&
      toggle?.['kinerja-ps-pegawai-perencanaan-v2-enabled']) ||
    false

  return {
    isPerencanaanV2: isPerencanaanV2,
  }
}
